import type { WasteCard } from '../data/cards';
import type { TeacherStats } from '../game/TeacherStats';

/** Hidden behind `?teacher` in the URL — mirrors DebugTools' `?debug` gating pattern. */
export class TeacherStatsPanel {
  private readonly root = this.getElement('#teacher-stats-panel');
  private readonly listEl = this.getElement('#teacher-stats-list');

  constructor(
    private readonly stats: TeacherStats,
    private readonly cards: WasteCard[],
  ) {
    this.getElement('#teacher-stats-reset').addEventListener('click', () => {
      this.stats.reset();
      this.render();
    });
    this.getElement('#teacher-stats-close').addEventListener('click', () => this.hide());
  }

  show(): void {
    this.render();
    this.root.hidden = false;
  }

  hide(): void {
    this.root.hidden = true;
  }

  private render(): void {
    const rows = this.stats.getStats(this.cards);
    this.listEl.innerHTML = '';
    if (rows.length === 0) {
      const item = document.createElement('li');
      item.textContent = '아직 기록된 오답이 없어요.';
      this.listEl.append(item);
      return;
    }
    for (const { card, missCount } of rows) {
      const item = document.createElement('li');
      item.textContent = `${card.nameKo} — ${missCount}회`;
      this.listEl.append(item);
    }
  }

  private getElement<T extends HTMLElement = HTMLElement>(selector: string): T {
    const element = document.querySelector<T>(selector);
    if (!element) throw new Error(`Missing element: ${selector}`);
    return element;
  }
}
